import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { mgcIconStopwatchRegular } from '@sb/mgc-icons/mgcIcon-stopwatch_regular.icon';
import { IconComponent, IconRegistry } from '@sb/ui/icon';

@Component({
  selector: 'sb-profile-clock-in-item',
  imports: [TranslatePipe, RouterModule, IconComponent],
  template: `
    <a class="flex w-full px-2">
      <div
        [routerLink]="['', { outlets: { modal: ['clock'] } }]"
        class="flex flex-1 items-center gap-3 rounded-lg bg-success-subtle px-3.5 py-4 text-xl font-bold text-success hover:bg-success/15 xl:px-1.5 xl:py-2 xl:text-lg xl:font-semibold"
      >
        <sb-icon class="size-5 xl:size-4" name="stopwatch-regular" />
        {{ 'Clock-in' | translate }}
      </div>
    </a>
  `,
})
export class SBProfileClockInItemComponent {
  constructor() {
    inject(IconRegistry).registerIcons([mgcIconStopwatchRegular]);
  }
}
